import { z } from 'zod';

export const registrationStepDateSchema = z.object({
    dob: z.string().min(1, { message: 'Дата обязательна' }).nullable(),
});

export type RegistrationStepDateType = z.infer<typeof registrationStepDateSchema>;
